<template>
  <div class="homePage">
    <meta name="format-detection" content="telephone=yes" />
    <div class="topSwiper">
      <div class="interiorBox">
        <div :class="item.imgClassName" v-for="(item, index) in bannerList">
          <div>
            <img
              class="top-img"
              :src="item.imgUrl + '-mokyun_site_banner_cover'"
              :alt="item.alt"
              :itle="item.alt"
            />
            <div class="writing">
              <div class="texts">
                <div>{{ imgText.title }}</div>
                <div>{{ imgText.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mk-progress">
        <div
          v-for="(item, index) in bannerList"
          class="bottom-color visible-sm-block visible-md-block visible-lg-block"
          @click="changeBanner(item.count, true)"
        >
          <div :class="item.className"></div>
        </div>
      </div>
    </div>
    <div class="solve row">
      <div class="col-md-12" style="text-align: center;">
        <div>解决方案</div>
        <div>Solution</div>
        <div></div>
      </div>
    </div>
    <div class="boding">
      <div class="container program">
        <div class="row">
          <div
            class="col-sm-6 col-md-1-5"
            v-for="(item, index) in precept"
            @click="consultPage(item.id)"
          >
            <div class="thumbnail">
              <div class="caption">
                <a herf="#" class="thumbnail animated" style="cursor: pointer;">
                  <img
                    :src="item.imgUrl"
                    style="width:100%;"
                    :alt="item.alt"
                    :title="item.alt"
                    title="南京小程序开发"
                    alt="南京小程序开发"
                  />
                  <div class="moudelDiv">
                    <div class="outerImg">
                      <img
                        :src="item.imgUrla"
                        class="outerImgc"
                        title="南京小程序开发"
                        alt="南京小程序开发"
                      />
                    </div>
                    <div class="texts">
                      <div class="title-texts">{{ item.title }}</div>
                      <div class="mk-texts">{{ item.texts }}</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="service execute" ref="numbers">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 col-md-3 ">
              <div>
                <div>
                  <div class="numbersA">{{ numData.city }}</div>
                  <span>+</span>
                </div>
                <div>服务城市</div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div>
                <div>
                  <div class="numbersB">{{ numData.customer }}</div>
                  <span>+</span>
                </div>
                <div>行业客户</div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div>
                <div>
                  <div class="numbersC">{{ numData.case }}</div>
                  <span>+</span>
                </div>
                <div>成熟案例</div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div>
                <div>
                  <div class="numbersD">{{ numData.user }}</div>
                  <span>w+</span>
                </div>
                <div>服务用户</div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="../assets/mk-bg.png"
          title="南京微信开发"
          alt="南京微信开发"
        />
      </div>
      <div class="solve row">
        <div class="col-md-12" style="text-align: center;">
          <div>优质案例</div>
          <div>Quality case</div>
          <div></div>
        </div>
      </div>

      <section class="jq22-container">
        <div class="container moudelBox">
          <div
            id="single"
            class="carousel slide"
            data-ride="carousel"
            data-shift="1"
          >
            <div
              class="carousel-inner caseCarousel"
              @mouseover="mouseover"
              ref="mouseEvent"
            >
              <ul
                class="row item active"
                v-for="(item, index) in caseData"
                style="padding-top: 20px;"
              >
                <li v-for="(list, index) in item" class="col-xs-4">
                  <div class="thumbnail" @click="goCase">
                    <img
                      :src="list.imgUrl"
                      title="南京微信开发"
                      alt="南京微信开发"
                      :alt="list.alt"
                      :title="list.alt"
                    />
                    <div class="caption">
                      <div class="textMoudel">
                        <div class="title">{{ list.title }}</div>
                        <div class="divide"></div>
                        <div class="text">{{ list.texts }}</div>
                      </div>
                    </div>
                    <div class="masking"></div>
                  </div>
                </li>
              </ul>
            </div>
            <a
              class="carousel-control left"
              href="#single"
              data-slide="prev"
              @click="countNumber"
              >Previous</a
            >
            <a
              class="carousel-control right"
              href="#single"
              data-slide="next"
              @click="nextNumber"
              >Next</a
            >
          </div>
        </div>
      </section>

      <div class="smallCarousel">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in newSwiper">
              <div class="thumbnail" @click="goCase">
                <img
                  :src="item.imgUrl"
                  alt="南京微信开发"
                  title="南京微信开发"
                />
                <div class="caption">
                  <div class="textMoudel">
                    <div class="title">{{ item.title }}</div>
                    <div class="divide"></div>
                    <div class="text">{{ item.texts }}</div>
                  </div>
                </div>
                <div class="masking"></div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination" style="bottom: -10px;"></div>
        </div>
      </div>

      <div class="flow">
        <div class="path">
          <div>服务流程</div>
          <div>Service Process</div>
          <div></div>
        </div>

        <div class="imgBox">
          <div class="topImg">
            <div>
              <img
                src="../assets/intention.png"
                title="南京微信开发"
                alt="南京微信开发"
              />
            </div>
            <div>
              <div>确立意向</div>
              <div>建立合作意向 明确项目需求</div>
            </div>
          </div>

          <img
            draggable="false"
            src="../assets/leftLine.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-sm-block visible-xs-block"
          />

          <div class="bottomImg">
            <div>
              <img
                draggable="false"
                title="南京微信开发"
                alt="南京微信开发"
                src="../assets/period.png"
              />
            </div>
            <div>
              <div>周期和费用</div>
              <div>确定项目设计 制作时间和费用</div>
            </div>
          </div>

          <img
            draggable="false"
            src="../assets/rightLine.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-sm-block visible-xs-block"
          />

          <div class="topImg">
            <div>
              <img
                draggable="false"
                title="南京微信开发"
                alt="南京微信开发"
                src="../assets/agreement.png"
              />
            </div>
            <div>
              <div>签署协议</div>
              <div>签署项目合同 支付启动定金</div>
            </div>
          </div>

          <img
            draggable="false"
            src="../assets/leftLine.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            class="visible-sm-block visible-xs-block"
          />

          <div class="bottomImg">
            <div>
              <img
                draggable="false"
                src="../assets/execute.png"
                title="南京微信开发"
                alt="南京微信开发"
              />
            </div>
            <div>
              <div>项目执行</div>
              <div>3-5个工作日确定设计风格</div>
            </div>
          </div>

          <img
            draggable="false"
            src="../assets/rightLine.png"
            title="南京微信开发"
            alt="南京微信开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            title="南京微信开发"
            alt="南京小程序开发"
            class="visible-sm-block visible-xs-block"
          />

          <div class="topImg">
            <div>
              <img
                draggable="false"
                src="../assets/sure.png"
                title="南京小程序开发"
                alt="南京小程序开发"
              />
            </div>
            <div>
              <div>修改及确认</div>
              <div>完成项目设计部分 并最终确认</div>
            </div>
          </div>

          <img
            draggable="false"
            src="../assets/leftLine.png"
            title="南京小程序开发"
            alt="南京小程序开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            title="南京小程序开发"
            alt="南京小程序开发"
            class="visible-sm-block visible-xs-block"
          />

          <div class="bottomImg">
            <div>
              <img
                draggable="false"
                src="../assets/accept.png"
                title="南京小程序开发"
                alt="南京小程序开发"
              />
            </div>
            <div>
              <div>项目验收</div>
              <div>支付尾款 并提交项目源文件</div>
            </div>
          </div>
          <img
            draggable="false"
            src="../assets/rightLine.png"
            title="南京小程序开发"
            alt="南京小程序开发"
            class="visible-md-block visible-lg-block"
          />
          <img
            draggable="false"
            src="../assets/vertical.png"
            title="南京小程序开发"
            alt="南京小程序开发"
            class="visible-sm-block visible-xs-block"
          />
          <div class="topImg">
            <div>
              <img
                draggable="false"
                src="../assets/afterSale.png"
                title="南京小程序开发"
                alt="南京小程序开发"
              />
            </div>
            <div>
              <div>售后服务</div>
              <div>项目结束提供免费6个月售后</div>
            </div>
          </div>
        </div>
      </div>
      <div class="solve row">
        <div class="col-md-12" style="text-align: center;">
          <div>优质客户</div>
          <div>High Quality Customers</div>
          <div></div>
        </div>
      </div>
      <div class="client">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3" v-for="item in imgUrl">
              <a class="thumbnail">
                <img
                  draggable="false"
                  :src="item[0]"
                  :alt="item[1]"
                  :title="item[1]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="submit">
        <div>
          <div class="demand">
            <div>提交需求</div>
            <div>Submit Requirements</div>
            <div></div>
          </div>
          <div class="container">
            <div class="inp row">
              <div class="col-md-3">
                <input type="text" placeholder="您的姓名" ref="name" />
              </div>
              <div class="col-md-3">
                <input type="text" placeholder="您的电话" ref="tel" />
              </div>
              <div class="col-md-6">
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="selectedOptions"
                  ref="address"
                  placeholder="请选择地址"
                ></el-cascader>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="inpArea row">
              <div class="col-md-12">
                <textarea
                  name=""
                  rows=""
                  cols=""
                  placeholder="您的需求"
                  ref="need"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="container" style="text-align: center;">
            <button @click="submitData">提交</button>
          </div>
        </div>
      </div>

      <div v-if="screenWidth < 460">
        <el-dialog title="提交成功" :visible.sync="dialogVisible" width="75%">
          <span>您也可以通过立即联系我们</span>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogVisible = false">取消联系</el-button> -->
            <el-button type="primary" @click="dialogVisible = false"
              ><a id="tel" href="tel:18012901065" style="color:#ffffff !import;"
                >电话联系</a
              ></el-button
            >
          </span>
        </el-dialog>
      </div>

      <div v-if="screenWidth > 460">
        <el-dialog title="提交成功" :visible.sync="dialogVisible" width="30%">
          <span>您也可以通过立即联系我们</span>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogVisible = false">取消联系</el-button> -->
            <el-button type="primary" @click="dialogVisible = false"
              ><a id="tel" href="tel:18012901065" style="color:#ffffff !import;"
                >电话联系</a
              ></el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import getData from '../api/getInfo';
import 'swiper/dist/css/swiper.min.css';

import image1 from '../assets/zigBee.png';
import image2 from '../assets/software.png';
import image3 from '../assets/industry.png';
import image4 from '../assets/operation.png';
import image5 from '../assets/cloud.png';

import imagea from '../assets/zigBee-a.png';
import imageb from '../assets/software-a.png';
import imagec from '../assets/industry-a.png';
import imaged from '../assets/operation-a.png';
import imagee from '../assets/cloud-a.png';

import {
  regionDataPlus,
  CodeToText,
  TextToCode,
} from 'element-china-area-data';

export default {
  data() {
    return {
      bannerList: [],
      numData: {},
      judge: 0,
      count: 0,
      precept: [
        {
          imgUrl: image2,
          imgUrla: imageb,
          title: '移动互联网应用软件',
          texts:
            '小程序、APP、公众号、企业门户、企业移动CRM、基于LBS智慧寻览、智慧新零售、小程序门户',
          id: 2,
          alt: '南京小程序开发',
        },
        {
          imgUrl: image1,
          imgUrla: imagea,
          title: '小程序云函数',
          texts:
            '提供高效的Serverless云函数服务，领先的技术架构，不仅仅是小程序，扩展无限',
          id: 1,
          alt: '南京小程序开发',
        },
        {
          imgUrl: image3,
          imgUrla: imagec,
          title: '小程序开放平台',
          texts:
            '提供完整的开发者套件，助力开发者更专注产品业务本身，更快的搭建属于自己的产品',
          id: 3,
          alt: '南京小程序开发',
        },

        {
          imgUrl: image5,
          imgUrla: imagee,
          title: '云服务',
          texts:
            '云函数私有化部署、短信服务、模版消息推送、性能监控、CDN存储/加速、数据可视化大屏',
          id: 5,
          alt: '南京小程序开发',
        },
        {
          imgUrl: image4,
          imgUrla: imaged,
          title: '产品咨询与开发实施',
          texts: '提供专业的软件产品咨询服务以及产品开发过程中进度追踪服务',
          id: 4,
          alt: '南京小程序开发',
        },
      ],
      options: regionDataPlus,
      selectedOptions: [],
      caseData: [],

      imgUrl: [],
      domWidth: '',
      newSwiper: [],
      scrollWatch: true,
      imgText: {},

      timer: null,
      number: 0,
      dialogVisible: false,
      screenWidth: 1200,

      caseList: [
        [
          {
            id: '32',
            name: '保粹评级',
            info: '拍卖类解决方案',
            pic: '1586835503740',
            desc:
              '拍卖行业的垂直解决方案，提供包括产品上拍、产品竞拍、拍品鉴别、拍品验证等多维度服务',
            sort: '0',
            label: '商城',
            qrcode: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
            appid: '23',
            imgUrl: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
          },
          {
            id: '8',
            name: '云鼎汇',
            info: '家具商城类解决方案',
            pic: '1539655819598',
            desc:
              '家具商城类解决方案，从用户选购热门产品，新品，挑选详细类别商品，全方位服务',
            sort: '1',
            label: '商城',
            qrcode: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
            imgUrl: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
            appid: '23',
          },
          {
            id: '9',
            name: '聚能签',
            info: '旅游行业智慧签证解决方案',
            pic: '1539655853564',
            desc:
              '专业的签证类解决方案，从用户发起签证，到用户落地海外地区，每一个流程都尽在掌握中。全方位的服务，无纸化的体验。',
            sort: '2',
            label: '服务',
            qrcode: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
            appid: '23',
            imgUrl: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
          },
        ],
        [
          {
            id: '2',
            name: '天津阳光',
            info: '地产行业解决方案',
            pic: '1539655661124',
            desc:
              '地产行业解决方案，提供包括热销楼盘、房贷计算，购房政策等服务，为用户提供便捷的购房体验',
            sort: '3',
            label: '服务',
            qrcode: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
            imgUrl: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
            appid: '23',
          },
          {
            id: '1',
            name: '泰通科技',
            info: '企业公众号解决方案',
            pic: '1539655632523',
            desc: '企业公众号解决方案 ，公众号消息，公众号服务，个人中心',
            sort: '4',
            label: '公众号',
            qrcode: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
            imgUrl: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
            appid: '23',
            detailUrl:
              'https://cdn1-open.mokyun.com/lq-izjkOBXyziiVJu4Qq-1AKY5pN',
          },

          {
            id: '5',
            name: '高科置业',
            info: '物业服务行业解决方案',
            pic: '1539655735311',
            desc:
              '物业服务行业解决方案，提供报修，反馈，活动等服务，为业主提供便捷的生活服务',
            sort: '4',
            label: '服务',
            qrcode: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
            imgUrl: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
            appid: '23',
          },
        ],

        // [
        //   {
        //     id: '6',
        //     name: '华光瑞芯',
        //     info: '工业行业解决方案',
        //     pic: '1539655754728',
        //     desc:
        //       '工业行业解决方案，提供产品展示，产品查询等服务为用户提供方便的服务',
        //     sort: '5',
        //     label: '医疗',
        //     qrcode: 'https://cdn1-open.mokyun.com/FrSXn-j8HDtM5lzSfQr61T-MoucS',
        //     imgUrl: 'https://cdn1-open.mokyun.com/FrSXn-j8HDtM5lzSfQr61T-MoucS',
        //     appid: '23',
        //   },
        //   {
        //     id: '30',
        //     name: '贝克曼博士',
        //     info: '健康',
        //     pic: '1548829094105',
        //     desc:
        //       '几十年来，贝克曼博士一直致力于解决那些令人心烦的污垢与污渍问题，为消费者提供“实用、专业、高品质”的污渍解决方案',
        //     sort: '5',
        //     label: '健康',
        //     qrcode: 'https://cdn1-open.mokyun.com/FhAceq5iSg1TTkukdGotWrq4N1qK',
        //     imgUrl: 'https://cdn1-open.mokyun.com/FhAceq5iSg1TTkukdGotWrq4N1qK',
        //     appid: '23',
        //   },
        //   {
        //     id: '7',
        //     name: '香港置地',
        //     info: '房地产发展解决方案',
        //     pic: '1539655779616',
        //     desc: '房地产发展解决方案，提供房地产发展，物业管理等服务',
        //     sort: '6',
        //     label: '企宣',
        //     qrcode: 'https://cdn1-open.mokyun.com/FmCs0lMXgByYS1zdy5g2rzGyIj4J',
        //     imgUrl: 'https://cdn1-open.mokyun.com/FmCs0lMXgByYS1zdy5g2rzGyIj4J',
        //     appid: '23',
        //   },
        // ],
        // [
        //   {
        //     id: '1',
        //     name: '泽沃酒仓',
        //     info: '酒类商城行业解决方案',
        //     pic: '1539655632523',
        //     desc:
        //       '酒类商城行业解决方案，提供浏览，购物，平团等服务，为用户提供便捷的购物体验',
        //     sort: '4',
        //     label: '商城',
        //     qrcode: 'https://cdn1-open.mokyun.com/FoG29KYLi0V5T1jPDLGikZoRF3AW',
        //     imgUrl: 'https://cdn1-open.mokyun.com/FoG29KYLi0V5T1jPDLGikZoRF3AW',
        //     appid: '23',
        //   },
        //   {
        //     id: '3',
        //     name: '泽沃佳酿 ',
        //     info: '电商解决方案',
        //     pic: '1539655685228',
        //     desc:
        //       '红酒垂直解决方案，针对行业特点，对电商环节进行深入定制，并配合深度运营，极大提升了产品知名度',
        //     sort: '8',
        //     label: '商城',
        //     qrcode: 'https://cdn1-open.mokyun.com/Ft9AuYEDyHuhZSNj47RLN5Q4kGm4',
        //     imgUrl: 'https://cdn1-open.mokyun.com/Ft9AuYEDyHuhZSNj47RLN5Q4kGm4',
        //     appid: '23',
        //   },
        //   {
        //     id: '4',
        //     name: 'MOKAI',
        //     info: 'AI助手解决方案',
        //     pic: '1539655711950',
        //     desc: 'AI助手解决方案，文案创作，做实做次，职场助手，育儿助手',
        //     sort: '7',
        //     label: '教育',
        //     qrcode: 'https://cdn1-open.mokyun.com/Fj9adbU-QckfS3UJja3y6evi2cAV',
        //     imgUrl: 'https://cdn1-open.mokyun.com/Fj9adbU-QckfS3UJja3y6evi2cAV',
        //     appid: '23',
        //   },
        // ],
      ],
      allList: [
        {
          id: '32',
          name: '保粹评级',
          info: '拍卖类解决方案',
          pic: '1586835503740',
          desc:
            '拍卖行业的垂直解决方案，提供包括产品上拍、产品竞拍、拍品鉴别、拍品验证等多维度服务',
          sort: '0',
          label: '商城',
          qrcode: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
          appid: '23',
          imgUrl: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
        },
        {
          id: '8',
          name: '云鼎汇',
          info: '家具商城类解决方案',
          pic: '1539655819598',
          desc:
            '家具商城类解决方案，从用户选购热门产品，新品，挑选详细类别商品，全方位服务',
          sort: '1',
          label: '商城',
          qrcode: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
          imgUrl: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
          appid: '23',
        },
        {
          id: '9',
          name: '聚能签',
          info: '旅游行业智慧签证解决方案',
          pic: '1539655853564',
          desc:
            '专业的签证类解决方案，从用户发起签证，到用户落地海外地区，每一个流程都尽在掌握中。全方位的服务，无纸化的体验。',
          sort: '2',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
          appid: '23',
          imgUrl: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
        },

        {
          id: '5',
          name: '高科置业',
          info: '物业服务行业解决方案',
          pic: '1539655735311',
          desc:
            '物业服务行业解决方案，提供报修，反馈，活动等服务，为业主提供便捷的生活服务',
          sort: '4',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
          imgUrl: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
          appid: '23',
        },

        {
          id: '1',
          name: '泰通科技',
          info: '企业公众号解决方案',
          pic: '1539655632523',
          desc: '企业公众号解决方案 ，公众号消息，公众号服务，个人中心',
          sort: '4',
          label: '公众号',
          qrcode: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
          imgUrl: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/lq-izjkOBXyziiVJu4Qq-1AKY5pN',
        },
        {
          id: '2',
          name: '天津阳光',
          info: '地产行业解决方案',
          pic: '1539655661124',
          desc:
            '地产行业解决方案，提供包括热销楼盘、房贷计算，购房政策等服务，为用户提供便捷的购房体验',
          sort: '3',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
          imgUrl: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
          appid: '23',
        },
        // {
        //   id: '6',
        //   name: '华光瑞芯',
        //   info: '工业行业解决方案',
        //   pic: '1539655754728',
        //   desc:
        //     '工业行业解决方案，提供产品展示，产品查询等服务为用户提供方便的服务',
        //   sort: '5',
        //   label: '医疗',
        //   qrcode: 'https://cdn1-open.mokyun.com/FrSXn-j8HDtM5lzSfQr61T-MoucS',
        //   imgUrl: 'https://cdn1-open.mokyun.com/FrSXn-j8HDtM5lzSfQr61T-MoucS',
        //   appid: '23',
        // },
        // {
        //   id: '2',
        //   name: '金地集团',
        //   info: '地产行业解决方案',
        //   pic: '1539655661124',
        //   desc:
        //     '地产行业解决方案，提供包括热销楼盘、房贷计算，购房政策等服务，为用户提供便捷的购房体验',
        //   sort: '3',
        //   label: '服务',
        //   qrcode: 'https://cdn1-open.mokyun.com/FpSwP58lhanb8nifPMnJHfTiHuzp',
        //   imgUrl: 'https://cdn1-open.mokyun.com/FpSwP58lhanb8nifPMnJHfTiHuzp',
        //   appid: '23',
        // },
        // {
        //   id: '1',
        //   name: '泽沃酒仓',
        //   info: '酒类商城行业解决方案',
        //   pic: '1539655632523',
        //   desc:
        //     '酒类商城行业解决方案，提供浏览，购物，平团等服务，为用户提供便捷的购物体验',
        //   sort: '4',
        //   label: '商城',
        //   qrcode: 'https://cdn1-open.mokyun.com/FoG29KYLi0V5T1jPDLGikZoRF3AW',
        //   imgUrl: 'https://cdn1-open.mokyun.com/FoG29KYLi0V5T1jPDLGikZoRF3AW',
        //   appid: '23',
        // },
        // {
        //   id: '30',
        //   name: '贝克曼博士',
        //   info: '健康',
        //   pic: '1548829094105',
        //   desc:
        //     '几十年来，贝克曼博士一直致力于解决那些令人心烦的污垢与污渍问题，为消费者提供“实用、专业、高品质”的污渍解决方案',
        //   sort: '5',
        //   label: '健康',
        //   qrcode: 'https://cdn1-open.mokyun.com/FhAceq5iSg1TTkukdGotWrq4N1qK',
        //   imgUrl: 'https://cdn1-open.mokyun.com/FhAceq5iSg1TTkukdGotWrq4N1qK',
        //   appid: '23',
        // },
        // {
        //   id: '7',
        //   name: '香港置地',
        //   info: '房地产发展解决方案',
        //   pic: '1539655779616',
        //   desc: '房地产发展解决方案，提供房地产发展，物业管理等服务',
        //   sort: '6',
        //   label: '企宣',
        //   qrcode: 'https://cdn1-open.mokyun.com/FmCs0lMXgByYS1zdy5g2rzGyIj4J',
        //   imgUrl: 'https://cdn1-open.mokyun.com/FmCs0lMXgByYS1zdy5g2rzGyIj4J',
        //   appid: '23',
        // },

        // {
        //   id: '3',
        //   name: '泽沃佳酿 ',
        //   info: '电商解决方案',
        //   pic: '1539655685228',
        //   desc:
        //     '红酒垂直解决方案，针对行业特点，对电商环节进行深入定制，并配合深度运营，极大提升了产品知名度',
        //   sort: '8',
        //   label: '商城',
        //   qrcode: 'https://cdn1-open.mokyun.com/Ft9AuYEDyHuhZSNj47RLN5Q4kGm4',
        //   imgUrl: 'https://cdn1-open.mokyun.com/Ft9AuYEDyHuhZSNj47RLN5Q4kGm4',
        //   appid: '23',
        // },
        // {
        //   id: '4',
        //   name: 'MOKAI',
        //   info: 'AI助手解决方案',
        //   pic: '1539655711950',
        //   desc: 'AI助手解决方案，文案创作，做实做次，职场助手，育儿助手',
        //   sort: '7',
        //   label: '教育',
        //   qrcode: 'https://cdn1-open.mokyun.com/Fj9adbU-QckfS3UJja3y6evi2cAV',
        //   imgUrl: 'https://cdn1-open.mokyun.com/Fj9adbU-QckfS3UJja3y6evi2cAV',
        //   appid: '23',
        // },
      ],
      smallList: [],
    };
  },

  mounted() {
    let caption = $('.carousel-inner .active li');
    let rightStop = this.$refs.rightStop;
    let dom = document.querySelector('body');
    $(window).on('scroll', () => {
      if (this.scrollWatch) {
        this.onScroll();
      }
    });

    this.getBanner(); // 轮播图
    // this.getServe(); // 服务信息
    this.getClient(); // 获取优质客户
    // 获取优质案例  返回Promise对象,等执行完请求再执行数据渲染 judePlace 函数
    this.getCase();
    this.getSmallList();
    this.judePlace();
    this.getSwipersData();
    // .then((res) => {
    //   this.judePlace();
    //   this.getSwipersData();
    // })
    // .catch((e) => {});

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?75d1af96b450c5590fffaae8357a65e0';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })();

    this.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
        if (this.screenWidth > 960) {
          this.asideShow = true;
        } else {
          this.asideShow = false;
        }
      })();
    };
  },

  beforecreated() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  destroyed() {
    this.scrollWatch = false;
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 获取轮播图
    getBanner() {
      let banner = [];
      let tempArr = {};
      let list = [
        {
          id: '2',
          title: '墨客云小程序',
          img_url: '1543569999751',
          jump_url: '',
          desc: '移动互联网应用软件开发：小程序、小游戏、APP、公众号、企业门户',
          cate: '0',
          sort: '6',
          status: '0',
          appid: '23',
        },
        {
          id: '3',
          title: 'Severless云函数',
          img_url: '1543569981789',
          jump_url: '',
          desc: '提供高效的Serverless云函数，让小程序开发更加敏捷、高效、稳定',
          cate: '0',
          sort: '5',
          status: '0',
          appid: '23',
        },
        {
          id: '1',
          title: '墨客云开放平台',
          img_url: '1543569990918',
          jump_url: '',
          desc:
            '提供完整的开发者套件，助力开发者更专注产品业务本身，更快的搭建属于自己的产品',
          cate: '0',
          sort: '4',
          status: '0',
          appid: '23',
        },
        {
          id: '4',
          title: '墨客云产品咨询',
          img_url: '1543568596824',
          jump_url: '',
          desc: '提供专业的软件产品咨询服务以及产品开发过程中进度追踪服务',
          cate: '0',
          sort: '3',
          status: '0',
          appid: '23',
        },
      ];
      // getData
      //   .getBanner()
      //   .then((res) => {
      list.forEach((val, index) => {
        tempArr = {};
        if (index % 3 == 0) tempArr.alt = '南京小程序开发';
        else if (index % 3 == 1) tempArr.alt = '南京小程序开发';
        else tempArr.alt = '南京小程序开发';
        tempArr.count = index;
        tempArr.imgUrl = `${getData.url}${val.img_url}`;
        tempArr.imgClassName = 'item';
        tempArr.className = 'bar';
        tempArr.title = val.title;
        tempArr.desc = val.desc;
        banner.push(tempArr);
      });

      banner[0].className = 'active bar';
      banner[0].imgClassName = 'item imgActive';
      this.imgText = banner[0];
      this.bannerList = banner;
      clearInterval(this.timer);
      this.timer = setInterval(this.interval, 7000);
      // })
      //   .catch((e) => {
      //     console.log(e);
      //   });
    },
    interval() {
      if (this.count >= this.bannerList.length - 1) {
        this.count = 0;
        this.changeBanner(this.count, false);
        return;
      } else {
        this.count++;
        this.changeBanner(this.count, false);
        return;
      }
      //				this.changeBanner(this.count, false)
    },
    // 轮播切换
    changeBanner(count, click) {
      //				console.log(count)
      if (click) {
        // 点击
        this.count = count;
      } else {
        // 自动切换
      }
      this.imgText = this.bannerList[count];
      this.bannerList.forEach((v, i) => {
        this.bannerList[i].className = 'bar';
      });
      this.bannerList.forEach((v, i) => {
        if (v.count == count) {
          this.bannerList[i].className = 'bar active';
        }
      });
      $('.imgActive').css({ marginLeft: `-${count * 100}%` });
    },

    // 获取服务信息
    getServe() {
      getData
        .getServe()
        .then((res) => {
          this.numData = res.data[0];
        })
        .catch((e) => {});
    },
    // 获取优质案例
    getCase() {
      let list = this.caseList[this.number];
      let tempArr = [];
      let dataList = [];
      let tempObj = {};
      let count = 0;
      list.forEach((val, index) => {
        if (count > 2) {
          tempArr = [];
          count = 0;
        }
        tempObj = {};
        if (index % 3 == 0) tempObj.alt = '南京小程序开发';
        else if (index % 3 == 1) tempObj.alt = '南京小程序开发';
        else tempObj.alt = '南京小程序开发';
        // tempObj.imgUrl = `${getData.url}${val.pic}`;
        tempObj.imgUrl = val.imgUrl;
        tempObj.title = val.name;
        tempObj.texts = val.desc;
        tempArr.push(tempObj);
        if (count == 2) dataList.push(tempArr);
        count++;
      });
      this.caseData = dataList;
    },

    getSmallList() {
      let list = this.allList;
      let tempArr = [];
      let dataList = [];
      let tempObj = {};
      let count = 0;
      list.forEach((val, index) => {
        if (count > 2) {
          tempArr = [];
          count = 0;
        }
        tempObj = {};
        if (index % 3 == 0) tempObj.alt = '南京小程序开发';
        else if (index % 3 == 1) tempObj.alt = '南京小程序开发';
        else tempObj.alt = '南京小程序开发';
        // tempObj.imgUrl = `${getData.url}${val.pic}`;
        tempObj.imgUrl = val.imgUrl;
        tempObj.title = val.name;
        tempObj.texts = val.desc;
        tempArr.push(tempObj);
        if (count == 2) dataList.push(tempArr);
        count++;
      });
      this.smallList = dataList;
    },

    // 获取优质客户
    getClient() {
      let clientList = [
        {
          id: '1',
          name: '东交',
          pic: '1539595693868',
          url: '',
          sort: '0',
          appid: '23',
        },
        {
          id: '2',
          name: '方太',
          pic: '1539595705234',
          url: '',
          sort: '1',
          appid: '23',
        },
        {
          id: '3',
          name: '民生银行',
          pic: '1539595720849',
          url: '',
          sort: '2',
          appid: '23',
        },
        {
          id: '4',
          name: '圣都装饰',
          pic: '1539595734455',
          url: '',
          sort: '3',
          appid: '23',
        },
        {
          id: '5',
          name: '苏果',
          pic: '1539595746660',
          url: '',
          sort: '4',
          appid: '23',
        },
        {
          id: '6',
          name: '江苏银行',
          pic: '1539595767347',
          url: '',
          sort: '5',
          appid: '23',
        },
        {
          id: '7',
          name: '中国邮政',
          pic: '1539595786197',
          url: '',
          sort: '6',
          appid: '23',
        },
        {
          id: '8',
          name: '金陵科技学院',
          pic: '1539595798939',
          url: '',
          sort: '6',
          appid: '23',
        },
      ];
      let data = [];
      clientList.forEach((val, index) => {
        data = [];
        data[0] = `${getData.url}${val.pic}`;
        if (index % 3 == 0) data[1] = '南京小程序开发';
        else if (index % 3 == 1) data[1] = '南京小程序开发';
        else data[1] = '南京小程序开发';
        this.imgUrl.push(data);
      });
      // })
      // .catch((e) => {});
    },

    getSwipersData() {
      for (var i in this.smallList) {
        for (var j in this.smallList[i]) {
          this.newSwiper.push(this.smallList[i][j]);
        }
      }
      if (this.newSwiper != []) this.swiper();
    },
    // 跳转资讯页
    consultPage(id) {
      this.$router.push({
        path: '/scheme',
        query: { id },
      });
    },
    goCase() {
      console.log('gogogo');
      this.$router.push({
        path: '/show',
      });
    },
    swiper() {
      //				console.log(666)
      var swiper = new Swiper('.swiper-container', {
        effect: 'flip',
        grabCursor: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          //		        nextEl: '.swiper-button-next',
          //		        prevEl: '.swiper-button-prev',
        },
      });
    },
    async submitData() {
      let phone = /^1[34578]\d{9}$/;
      let name = this.$refs.name.value;
      let tel = this.$refs.tel.value;
      let code = this.$refs.address.value;
      let address = `${CodeToText[code[0]]}${CodeToText[code[1]]}${
        CodeToText[code[2]]
      }`;
      let need = this.$refs.need.value;
      if (name === '') this.$message.error('请填写姓名');
      else {
        if (tel === '' || !phone.test(tel))
          this.$message.error('请填写正确的电话');
        else {
          if (address == '') this.$message.error('请选择地址');
          else {
            if (need == '') this.$message.error('请填写需求');
            else {
              console.log(name, tel, need);
              const raw = JSON.stringify({
                name: name,
                mobile: tel,
                content: need,
                address,
              });
              await fetch(
                'https://s1.box.mokyun.com/bdea6316-2ed8-4554-a654-9a0a9a378adc/Config/setFeedback',
                {
                  method: 'POST',
                  body: raw,
                },
              ).catch((error) => {
                return error;
              });
              // getData
              //   .subDemand({
              //     name: name,z
              //     tel: tel,
              //     address: address,
              //     demand: need,
              //   })
              //   .then((res) => {
              //     // console.log(res.data)
              //     // 									if (res.data == "success") {
              //     // 										this.$message({
              //     // 											message: '提交成功',
              //     // 											type: 'success'
              //     // 										});
              //     // 										this.$refs.name.value = ''
              //     // 										this.$refs.tel.value = ''
              //     // 										this.selectedOptions = []
              //     // 										this.$refs.need.value = ''
              //     // 									} else this.$message.error('提交失败');
              //   })
              //   .catch((e) => {});
              setTimeout(() => {
                // this.$message({
                //   message: '提交成功',
                //   type: 'success',
                // });
                this.dialogVisible = true;
                this.$refs.name.value = '';
                this.$refs.tel.value = '';
                this.selectedOptions = [];
                this.$refs.need.value = '';
              }, 800);
            }
          }
        }
      }
    },

    // 鼠标滚动
    onScroll() {
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 解决方案动画
      var showText = function() {
        $('.moudelDiv .outerImg').addClass('animated fadeInDown');
        $('.moudelDiv .texts').addClass('animated fadeInUp');
      };
      // 服务流程动画
      var flow = function() {
        $('.flow .imgBox>div').addClass('animated bounceInLeft');
        $('.flow .imgBox>img').addClass('animated bounceInRight');
      };
      // 优质客户
      var client = function() {
        $('.client .container .row div a').addClass('animated flipInX');
      };
      // 执行解决方案动画
      this.judeSite(showText, $('.program'));
      this.judeSite(flow, $('.flow .imgBox'));
      this.judeSite(client, $('.client .container'));

      // 执行数字增加
      this.judeNum(
        this.addNum,
        $('.execute .row .numbersA'),
        30,
        $('.execute .container .row'),
      );
      this.judeNum(
        this.addNum,
        $('.execute .row .numbersB'),
        100,
        $('.execute .container .row'),
      );
      this.judeNum(
        this.addNum,
        $('.execute .row .numbersC'),
        200,
        $('.execute .container .row'),
      );
      this.judeNum(
        this.addNum,
        $('.execute .row .numbersD'),
        100,
        $('.execute .container .row'),
      );
    },
    // 判断方案是否可见
    judeSite(fn, temp) {
      let result =
        temp.offset().top >= $(window).scrollTop() &&
        temp.offset().top < $(window).scrollTop() + $(window).height(); // 判断是否可见
      if (result) {
        fn();
      }
    },
    // 判断数字是否可见
    judeNum(fn, ele, num, temp) {
      let result =
        temp.offset().top >= $(window).scrollTop() &&
        temp.offset().top < $(window).scrollTop() + $(window).height(); // 判断是否可见
      if (result) {
        fn(ele, num);
      }
    },
    // 数字增加
    addNum(temp, num) {
      temp.animate(
        { count: num },
        {
          duration: 2000,
          step: function() {
            temp.text(String(parseInt(this.count)));
          },
        },
      );
    },

    // 循环绑定移入事件
    mouseover(e) {
      let lis = this.$refs.mouseEvent.querySelectorAll('.active li');
      for (var i = 0; i < 3; i++) {
        // 进入
        lis[i]
          .querySelector('.thumbnail')
          .addEventListener('mouseover', function() {
            //						this.querySelector('.masking').className = 'masking show animated bounceInDown'  // 鼠标移入加蒙版
            this.style.boxShadow = '0px 8px 38px 0px rgba(94, 114, 169, 0.15)';
            this.querySelector('.caption').style.textShadow =
              '3px 3px 10px #aaa';
            this.style.marginTop = '-10px';
          });
        // 离开
        lis[i]
          .querySelector('.thumbnail')
          .addEventListener('mouseout', function() {
            //						this.querySelector('.masking').className = 'masking hide animated rotateOutDownLeft' // 鼠标移出去除蒙版
            this.style.boxShadow = 'none';
            this.querySelector('.caption').style.textShadow = 'none';
            this.style.marginTop = '0';
          });
      }
    },
    countNumber() {
      this.number = Number(this.number - 1);
      if (this.number === -1) {
        this.number = 1;
      }

      this.getCase();
    },
    nextNumber() {
      this.number = Number(this.number + 1);
      if (this.number === 2) {
        this.number = 0;
      }

      this.getCase();
    },
    // 优质案例下轮播效果
    judePlace() {
      let carousels = $('#single');
      carousels.each(function() {
        var $obj = $(this);
        var $inner = $obj.find('.caseCarousel');
        var id = 'uuid' + new Date().getTime();
        $obj.addClass(id);
        if ($obj.data('shift') === 1) {
          var items = $obj.find('.item > [class*="col-"]'),
            visibleCnt = $obj.find('.item:first [class*="col-"]').length,
            wrapper = '';
          var rule_base = '.carousel.' + id + ' .carousel-inner > .item',
            styles = $('<style></style>'),
            rules = [];
          rules[0] =
            rule_base +
            '.next {left: ' +
            100 / visibleCnt +
            '%; transform: none;}';
          rules[1] = rule_base + '.active {left: 0;}';
          rules[2] =
            rule_base +
            '.active.left {left: -' +
            100 / visibleCnt +
            '%; transform: none;}';
          rules[3] = rule_base + '.next.left {left: 0;}';
          rules[4] =
            rule_base +
            '.active.right {left: ' +
            100 / visibleCnt +
            '%; transform: none;}';
          rules[5] = rule_base + '.prev.right {left: 0;}';
          rules[6] =
            rule_base +
            '.prev {left: -' +
            100 / visibleCnt +
            '%; transform: none;}';
          for (var i = 0; i < rules.length; i++) {
            styles.append(rules[i]);
          }
          $obj.prepend(styles);
          for (var i = 0; i < $(items).length; i++) {
            var $item = $(items[i]);
            var parent = $item.parent();
            if (parent.hasClass('item')) {
              if (!wrapper.length) {
                wrapper = parent
                  .clone()
                  .removeClass('active')
                  .html('');
              }
              $item.unwrap();
            }
            var itemGroup = [$item];
            for (var x = 1; x < visibleCnt; x++) {
              var a = i + x;
              var next = $(items[a]);
              if (!next.length) {
                next = $(items[a - $(items).length]);
              }
              itemGroup[x] = next.clone();
            }
            var newSet = wrapper.clone().html(itemGroup);
            if (i == 0) {
              newSet.addClass('active');
            }
            newSet.appendTo($inner);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.homePage {
  width: 100%;
  font-size: 16px;
}

>>> #tel {
  color: #fff !important;
}

>>> .el-input__inner {
  background-color: #f7f7f7 !important;
  border: 1px solid #f7f7f7 !important;
}

.row {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
}

a {
  color: #42b983;
}
.hello .swiper-wrapper .swiper-slide {
  text-align: center;
}

.swiper-wrapper .swiper-slide img {
  width: 100%;
  height: 100%;
}

#myCarousel .carousel-inner img {
  width: 100%;
  height: 100%;
}

.topSwiper {
  width: 100%;
  margin-bottom: 6.3rem;
  overflow: hidden;
  position: relative;
}
.interiorBox {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.interiorBox .moudleBox {
  height: 430px;
}
.interiorBox > div {
  width: 100%;
  flex: none;
  transition: all 0.8s ease;
}
.interiorBox > div img {
  width: 100%;
}
.interiorBox .writing {
  width: 100%;
  height: 100%;
  position: absolute;
  transform: translateY(-100%);
}

@media only screen and (max-width: 360px) {
  .interiorBox > div img {
    height: 160px;
  }
}

.imgActive {
  position: relative;
}
.writing .texts {
  width: 50%;
  height: 100%;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.writing .texts > div:nth-child(1) {
  font-size: 6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.writing .texts > div:nth-child(2) {
  font-size: 2rem;
}
@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .writing .texts > div:nth-child(1) {
    font-size: 4rem;
  }
  .writing .texts > div:nth-child(2) {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .writing .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .writing .texts > div:nth-child(2) {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 768px) {
  .writing .texts > div:nth-child(1) {
    font-size: 1rem;
  }
  .writing .texts > div:nth-child(2) {
    font-size: 0.5rem;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .top-img {
    height: 100%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .top-img {
    height: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .top-img {
    height: 260px;
    object-fit: cover;
  }
}
.mk-progress {
  width: 100%;
  position: absolute;
  bottom: 5%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.bottom-color {
  width: 2%;
  height: 6px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 10px;
  cursor: pointer;
  /* border-radius: 1px; */
}
.bottom-color .active {
  background: #fff;
  height: 100%;
  animation: changecolor 7s linear;
  /* border-radius: 1px; */
}
@keyframes changecolor {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.solve {
  width: 100%;
}

.solve .col-md-12 > div:nth-child(1) {
  font-family: MicrosoftYaHei;
  font-size: 3rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #619cf5;
}

.solve .col-md-12 > div:nth-child(2) {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #e1e1e1;
}

.solve .col-md-12 > div:nth-child(3) {
  width: 50px;
  height: 4px;
  background-color: #619cf5;
  border-radius: 2px;
  margin: 0 auto;
}

@media only screen and (min-width: 550px) and (max-width: 760px) {
  .boding {
    margin-top: 3rem;
  }
  .topSwiper {
    margin-bottom: 3rem;
  }
  .solve .col-md-12 > div:nth-child(1) {
    font-size: 2rem;
    line-height: 25px;
  }
  .solve .col-md-12 > div:nth-child(2) {
    font-size: 15px;
  }
  .solve .col-md-12 > div:nth-child(3) {
    width: 38px;
    height: 3px;
  }
}

@media (max-width: 550px) {
  .boding {
    margin-top: 1rem;
  }
  .topSwiper {
    margin-bottom: 1.8rem;
  }
  .solve .col-md-12 > div:nth-child(1) {
    font-size: 1.9rem;
    line-height: 25px;
  }
  .solve .col-md-12 > div:nth-child(2) {
    font-size: 13px;
  }
  .solve .col-md-12 > div:nth-child(3) {
    width: 32px;
    height: 2px;
  }
}

.col-xs-1-5,
.col-sm-1-5,
.col-md-1-5,
.col-lg-1-5 {
  min-height: 1px;
  position: relative;
}

.col-xs-1-5 {
  width: 20%;
  float: left;
}

@media (min-width: 768px) {
  .col-sm-1-5 {
    width: 20%;
    float: left;
  }
}

@media (min-width: 992px) {
  .col-md-1-5 {
    width: 20%;
    float: left;
  }
}

@media (min-width: 1200px) {
  .col-lg-1-5 {
    width: 20%;
    float: left;
  }
}
.program .row .col-sm-6 {
  padding: 0 !important;
}
.row .col-md-1-5 .thumbnail {
  display: block;
  margin-bottom: 0px;
  padding: 0;
  line-height: 1.42857143;
  background-color: #fff;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  border: 0;
  border-radius: none;
  position: relative;
}

.thumbnail .moudelDiv {
  position: absolute;
  top: 0;
  height: 0;
  width: 100%;
  height: 100%;
}

.thumbnail .moudelDiv > div {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.thumbnail .moudelDiv > div:nth-child(2) {
  justify-content: flex-start;
}

.thumbnail .moudelDiv > div:nth-child(2) > div:nth-child(1) {
  width: 90%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #ffffff;
}
.thumbnail .moudelDiv .mk-texts {
  width: 80%;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #ffffff;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.boding {
  margin-top: 5rem;
}

.boding .program {
  width: 85%;
}

@media only screen and (min-width: 1410px) and (max-width: 1650px) {
  .boding .program {
    width: 90% !important;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1410px) {
  .boding .program {
    width: 100% !important;
  }
}
@media only screen and (min-width: 769px) and (max-width: 991px) {
  .boding .program {
    width: 100% !important;
  }
  .boding .program .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
}

/* @media only screen and (min-width: 623px) and (max-width: 768px) {
  .boding .program {
    width: 100% !important;
  }
  .boding .program .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
} */

@media (max-width: 768px) {
  .boding .program {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0px !important;
  }
  /* .boding .program .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  } */
  /* .boding .program .row .col-md-1-5 {
    width: 50%;
  } */

  /* .thumbnail .moudelDiv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  } */
  /* .thumbnail .moudelDiv .mk-texts {
    width: 50%;
    text-align: center;
    font-size: 12px;
    padding-bottom: 50px;
  } */
  /* .thumbnail .moudelDiv .title-texts {
    font-size: 12px;
    letter-spacing: 0px;
    color: #ffffff;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    padding-bottom: 30px;
  } */
  /* .thumbnail .moudelDiv .outerImg .outerImgc {
    width: 40px;
  } */
}

.service {
  width: 100%;
  padding: 4.5rem 0 3.4rem;
  margin: 7.5rem 0 6.8rem;
  position: relative;
}
.service img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.service .col-md-3 > div {
  color: white;
  width: 100%;
  text-align: center;
}

.service .col-md-3 > div > div:nth-child(1) {
  font-family: BERNIERREGULAR;
  font-size: 5rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 60px;
  letter-spacing: 0px;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.service .col-md-3 > div > div:nth-child(2) {
  font-family: MicrosoftYaHei;
  font-size: 2.5rem;
  font-weight: normal;
  letter-spacing: 0px;
  margin-bottom: 2.5rem;
}

@media only screen and (min-width: 650px) and (max-width: 992px) {
  .service .col-md-3 > div > div:nth-child(1) {
    font-size: 3.2rem;
  }
  .service .col-md-3 > div > div:nth-child(2) {
    font-size: 2.3rem;
    margin-bottom: 2.3rem;
  }
}

@media (max-width: 650px) {
  .service .col-md-3 > div > div:nth-child(1) {
    font-size: 2.5rem;
  }
  .service .col-md-3 > div > div:nth-child(2) {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
}

.flow {
  width: 100%;
  background: #404040;
  margin-bottom: 4.6em;
  padding: 4em 0;
}

.path {
  width: 100%;
  text-align: center;
}

.path > div:nth-child(1) {
  font-size: 40px;
  font-family: MicrosoftYaHei;
  color: #8caaff;
  margin-bottom: 10px;
}

.path > div:nth-child(2) {
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 20px;
}

.path > div:nth-child(3) {
  width: 50px;
  height: 4px;
  border-radius: 2px;
  background: #8caaff;
  margin: 0 auto;
}
@media only screen and (min-width: 550px) and (max-width: 760px) {
  .flow {
    padding: 2.5em 0;
  }
  .path > div:first-child {
    font-size: 2rem;
    line-height: 25px;
  }
  .path > div:nth-child(2) {
    font-size: 15px;
    margin-bottom: 15px;
  }
  .path > div:nth-child(3) {
    width: 38px;
    height: 3px;
    margin-bottom: 10px;
  }
}

@media (max-width: 550px) {
  .flow {
    padding: 2em 0;
  }
  .path > div:first-child {
    font-size: 1.9rem;
    line-height: 25px;
  }
  .path > div:nth-child(2) {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .path > div:nth-child(3) {
    width: 32px;
    height: 2px;
    margin-bottom: 10px;
  }
}

.imgBox {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex: row;
  justify-content: center;
}

.imgBox > img {
  width: 7.5%;
  height: 60%;
  margin-top: 8%;
}

.imgBox > div {
  width: 7.5%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.imgBox > div > div:nth-child(1) {
  line-height: 50px;
  text-align: center;
}

.imgBox > div > div:nth-child(2) > div {
  text-align: center;
}

.imgBox > div > div:nth-child(2) > div:nth-child(1) {
  width: 100%;
  height: 50%;
  line-height: 1.8em;
  font-size: 18px;
  color: #fff;
}

.imgBox > div > div:nth-child(2) > div:nth-child(2) {
  width: 100%;
  font-size: 14px;
  line-height: 2em;
  color: rgba(255, 255, 255, 0.6);
}

.imgBox > div div img {
  width: 100%;
  height: 100%;
}

.imgBox .topImg {
  margin-top: 2%;
}

.imgBox .bottomImg {
  margin-top: 10%;
}

.client {
  width: 100%;
  margin-top: 4.3em;
  margin-bottom: 5.8em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.client .container {
  width: 75%;
}

.client .container .thumbnail {
  border: none;
}

/* .client .container .row .col-md-6 {
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
} */

.client .container .row .thumbnail img {
  width: 100%;
  height: 50%;
  margin-bottom: 1em;
  cursor: pointer;
}
.client .container .row .thumbnail img:hover {
  box-shadow: 0px 8px 38px rgba(120, 114, 169, 0.15);
  transform: scale(1.1);
  transition: all 0.5s ease-in-out;
}

/* @media only screen and (min-width: 550px) and (max-width: 768px) {
  .client {
    margin-bottom: 3em;
  }
  .client .container {
    width: 70%;
  }
} */

@media (max-width: 768px) {
  .client {
    margin-bottom: 1.8em;
  }
  .client .container {
    width: 100%;
    /* display: flex;
    align-items: center;
    flex-wrap: wrap; */
  }
  .client .container .row .col-md-3 {
    width: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
}

.submit {
  width: 100%;
  padding-top: 4.5em;
  padding-bottom: 4em;
  background: url(../assets/bg.png);
  background-size: 100%;
}
.submit > div {
  width: 62%;
  margin: 0 auto;
  background: white;
  border-top: 0.1px solid #fff;
  padding-bottom: 3.3em;
}

.demand {
  width: 100%;
  text-align: center;
  margin-top: 42px;
  margin-bottom: 20px;
}

.demand > div:nth-child(1) {
  font-size: 3.5rem;
  font-family: MicrosoftYaHei;
  color: #619cf5;
  margin-bottom: 10px;
}

.demand > div:nth-child(2) {
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: #e1e1e1;
  margin-bottom: 20px;
}

.demand > div:nth-child(3) {
  border-radius: 2px;
  background: #619cf5;
  margin-bottom: 20px;
  margin: 0 auto;
}

@media only screen and (min-width: 768px) and (max-width: 1350px) {
  .submit > div {
    width: 80%;
  }
  .client .container {
    width: 88%;
  }
}

@media only screen and (min-width: 550px) and (max-width: 768px) {
  .demand {
    margin-top: 20px;
  }
  .demand > div:first-child {
    font-size: 2.8rem;
  }
  .demand > div:nth-child(2) {
    font-size: 18px;
  }
  .submit {
    padding-top: 0.5em;
    padding-bottom: 4em;
  }
  .client .container {
    width: 100%;
  }
}

@media (max-width: 550px) {
  .demand {
    margin-top: 0;
  }
  .demand > div:first-child {
    font-size: 1.8rem;
  }
  .demand > div:nth-child(2) {
    font-size: 15px;
  }
  .submit {
    padding-top: 0;
    padding-bottom: 0;
  }
  .submit .container {
    padding: 0 !important;
  }
  .client .container {
    width: 100% !important;
    padding: 0 !important;
  }
}

.submit .inp {
  margin: 0 auto 22px;
}

.submit .inp .col-md-3 {
  margin-bottom: 10px;
}

.submit .inp input {
  width: 100%;
  min-height: 40px;
  outline: none;
  background: #f7f7f7;
  border: none;
  padding-left: 1em;
}

.submit .inpArea {
  margin: 0 auto 26px;
}

.submit .inpArea textarea {
  resize: none;
  width: 100%;
  min-height: 180px;
  outline: none;
  background: #f7f7f7;
  border: none;
  padding-left: 1em;
  padding-top: 15px;
}

.submit button {
  width: 35%;
  min-height: 45px;
  background-color: #5d84f3;
  /*box-shadow: 0px 28px 65px 0px #5d84f3;*/
  color: #fff;
  outline: none;
  border: none;
  border-radius: 2px;
  font-size: 2.2rem;
  font-family: MicrosoftYaHei;
  cursor: pointer;
  margin: 0 auto;
  border-radius: 30px;
}
@media only screen and (max-width: 768px) {
  .submit {
    background: white;
  }
  .submit > div {
    width: 100%;
  }
  .submit button {
    font-size: 1em;
  }
}

.jq22-container {
  margin: 2.8em 0 6.3em;
}

.jq22-container .moudelBox {
  min-width: 70%;
}

.jq22-container .thumbnail {
  width: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
}

.jq22-container .moudelBox img {
  width: 100%;
}

.jq22-container .thumbnail .caption {
  min-height: 14em;
  padding-top: 1.3em;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.jq22-container .thumbnail .caption .textMoudel {
  width: 90%;
  margin: 0 auto;
}

.jq22-container .thumbnail .caption .textMoudel .title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jq22-container .thumbnail .caption .textMoudel .divide {
  width: 20%;
  height: 4px;
  margin-bottom: 1.4em;
  background-color: rgba(93, 132, 243, 0.4);
  opacity: 0.4;
  transition: 0.8s ease-in-out;
}

.jq22-container .thumbnail .caption .textMoudel .text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  transition: 0.8s ease-in-out;
}

.smallCarousel .thumbnail {
  width: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
}
.smallCarousel .thumbnail .caption {
  min-height: 14em;
  padding-top: 1.3em;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.smallCarousel .thumbnail .caption .textMoudel {
  width: 90%;
  margin: 0 auto;
}

.smallCarousel .thumbnail .caption .textMoudel .title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.smallCarousel .thumbnail .caption .textMoudel .divide {
  width: 20%;
  height: 4px;
  margin-bottom: 1.4em;
  background-color: rgba(93, 132, 243, 0.4);
  opacity: 0.4;
  transition: 0.8s ease-in-out;
}

.smallCarousel .thumbnail .caption .textMoudel .text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  transition: 0.8s ease-in-out;
}

@media only screen and (min-width: 992px) and (max-width: 1450px) {
  .jq22-container .moudelBox {
    min-width: 90%;
  }
}
@media only screen and (max-width: 992px) {
  .jq22-container .moudelBox {
    min-width: 100%;
  }
  .imgBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .imgBox > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0;
  }
  .imgBox > div > div {
    height: 100%;
    text-align: right;
  }
  .imgBox > div > div > img {
    width: 50%;
    height: 100%;
  }
  .imgBox .bottomImg {
    margin: 0;
  }
  .imgBox div > div:nth-child(2) > div {
    text-align: left;
  }
  .imgBox > img {
    margin: 3% auto;
    width: 3%;
    height: 20%;
  }
}
@media only screen and (max-width: 769px) {
  .jq22-container {
    display: none;
  }
  .smallCarousel {
    display: block;
    margin: 2.8em 0 6.3em;
  }
  .outBox nav {
    background-color: red;
  }
}
@media only screen and (min-width: 769px) {
  .jq22-container {
    display: block;
  }
  .smallCarousel {
    display: none;
  }
}
.smallCarousel {
  width: 100%;
}
.smallCarousel .swiper-container {
  width: 85%;
  margin: 0 auto;
}
.smallCarousel .swiper-container .thumbnail:hover {
  box-shadow: 0px 8px 38px 0px rgba(94, 114, 169, 0.15);
  text-shadow: 3px 3px 10px #aaa;
  margin-top: -3px;
}
.smallCarousel .swiper-container .swiper-slide {
}
.smallCarousel .swiper-container .swiper-slide img {
  width: 100%;
}
.jq22-container .moudelBox ul li .thumbnail {
  position: relative;
}
.jq22-container .moudelBox ul li .thumbnail .masking {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.6;
  border-radius: 3px;
}
.jq22-container .moudelBox ul li .thumbnail .show {
  display: block;
}
.jq22-container .moudelBox ul li .thumbnail .hide {
  display: none;
}
.program .row .col-md-1-5 .moudelDiv .animated {
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
}
/*解决方案下鼠标移入动画*/
/*.program .row .col-md-1-5 .thumbnail:hover{
		transform-origin: top center;
		animation-name: swing
	}*/
@keyframes swing {
  20% {
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
  }
  40% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
  60% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }
  80% {
    -webkit-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }
  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
.flow .imgBox .bounceInLeft {
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
}
.flow .imgBox .bounceInRight {
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
}
.client .container .row .flipInX {
  animation-duration: 2.5s;
  -webkit-animation-duration: 2.5s;
}
.el-cascader {
  width: 100%;
}
/* ::v-deep .el-cascader .el-input__inner {
  background: #f7f7f7 !important;
  border: 1px solid #f7f7f7 !important;
} */
@media (min-width: 768px) {
  .submit .container {
    width: 100% !important;
  }
}
@media (max-width: 768px) {
  .topSwiper {
    margin-top: 51px;
  }
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #bbb;
  font-size: 14px;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bbb;
  font-size: 14px;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bbb;
  font-size: 14px;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #bbb;
  font-size: 14px;
}
/* ::v-deep .el-input--suffix .el-input__inner {
  outline: none !important;
  background: #f7f7f7 !important ;
  border: none !important;
} */
</style>



// WEBPACK FOOTER //
// src/view/index.vue